<nav class="nav">
  <div class="nav-left">
    <a class="nav-item logo" routerLink="/">
      <img src="assets/images/gamebit_black.png" width="120px" alt="Firestarter Angular4 Demo App" />
    </a>
  </div>

  <!-- This "nav-toggle" hamburger menu is only visible on mobile -->
  <!-- You need JavaScript to toggle the "is-active" class on "nav-menu" -->
  <span class="nav-toggle" (click)="toggleCollapse()" [ngClass]="{'is-active': show}">
    <span></span>
    <span></span>
    <span></span>
  </span>

  <!-- This "nav-menu" is hidden on mobile -->
  <!-- Add the modifier "is-active" to display it on mobile -->
  <div class="nav-right nav-menu" [ngClass]="{'is-active': show}">
    <a class="nav-item" routerLink="/about-us">
      About Us
    </a>
    <a class="nav-item" routerLink="/apps">
      Apps
    </a>
    <!-- <a class="nav-item" routerLink="/test">
      Test
    </a>
    <a class="nav-item" routerLink="/login">
      Login
    </a> -->
    <!-- <a class="nav-item" routerLink="/notes">
      Firestore
    </a>

    <a class="nav-item" routerLink="/items">
      Realtime DB
    </a>
    <a class="nav-item" routerLink="/uploads">
      File Uploads
    </a> -->
  </div>
</nav>


// WEBPACK FOOTER //
// ./src/app/ui/top-nav/top-nav.component.html